<template>
  <ul id="login-dropdown" class="login-dropdown" aria-hidden="true">
    <li>
      <Button value="Sittercity Log In" variant="outlined" size="small" :href="loginUrl" />
    </li>
    <li>
      <Button value="Years Ahead Log In" variant="outlined" size="small" href="https://www.yearsahead.com/seeker/login" />
    </li>
  </ul>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';

export default {
  name: 'CorporateHeaderDropdown',
  components: { Button },
  props: {
    slug: String,
  },
  computed: {
    loginUrl(): string {
      return this.slug ? `/login?corporate_slug=${this.slug}` : '/login';
    },
  },
};
</script>
